import { Banner, Link } from '@cobliteam/ui/components';

import { EventCategory, EventTrigger, type MediaEvent } from '@cobliteam/common-types';

import FeedbackModal from '@cobliteam/media/src/containers/FeedbackModal';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';
import useImpactEvent from '@cobliteam/hooks/src/useImpactEvent';

import TagFeatures from '@cobliteam/ui-business/components/Tag/Features';

import { BannerActions, BannerContent, BannerIcon, BannerTitle } from '@cobliteam/ui/components/Banner';

import useMediaStore from '../../../../store/zustand/useMediaStore';

export interface MediaDialogBannerProps {
  isFetchingMediaRows?: boolean;
}

const MediaDialogBanner = ({ isFetchingMediaRows }: MediaDialogBannerProps) => {
  const mediaViewId = useMediaStore((state) => state.mediaViewId);
  const { data: mediaView } = useGetMediaView(mediaViewId);
  const mediaData = mediaView?.mediaInfo;
  const mediaDetails = mediaData?.mediaDetails;

  if (!mediaData || isFetchingMediaRows) {
    return;
  }

  const { eventTrigger } = mediaDetails as MediaEvent;
  const { isEventTriggerEnabled } = useImpactEvent();
  const trackEventName = 'Impact Event Feedback Modal Submited';
  const descriptionText = 'Abaixo deixe sua opinião sobre o novo evento de impacto e trepidação:';
  const eventCategory = EventCategory.ACCELEROMETER;
  const displayMediaBanner = eventTrigger === EventTrigger.COLLISION && isEventTriggerEnabled(eventTrigger);
  const linkFaq = 'https://suporte.cobli.co/como-os-eventos-de-dire%C3%A7%C3%A3o-distra%C3%ADda-s%C3%A3o-gerados?hs_preview=CBdictMy-177343379618';

  return (
    displayMediaBanner && (
      <div className='px-3 py-4'>
        <Banner>
          <BannerIcon icon={<TagFeatures.Beta variant='outlined' label='Beta' />} />
          <BannerContent>
            <BannerTitle>Este é um novo evento em fase de testes, confira como ele funciona e compartilhe sua opinião. </BannerTitle>
            <Link size='sm' target='_blank' href={linkFaq}>
              Saiba mais
            </Link>
          </BannerContent>
          <BannerActions>
            <FeedbackModal trackEventName={trackEventName} descriptionText={descriptionText} eventCategory={eventCategory} />
          </BannerActions>
        </Banner>
      </div>
    )
  );
};

export default MediaDialogBanner;
